import { render, staticRenderFns } from "./DashboardOrdersList.vue?vue&type=template&id=92493318&"
import script from "./DashboardOrdersList.vue?vue&type=script&lang=js&"
export * from "./DashboardOrdersList.vue?vue&type=script&lang=js&"
import style0 from "./DashboardOrdersList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports